import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oralna-hirurgija',
  templateUrl: './oralna-hirurgija.component.html',
  styleUrls: ['./oralna-hirurgija.component.css']
})
export class OralnaHirurgijaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
